import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const gameYearApi = {
    getList(status = '0,1,2,3') {
        return httpClient.get(API_ROUTES.gameYear_list, {
            params: { status },
        })
    },

    getInfo(gameYearId) {
        return httpClient.get(API_ROUTES.gameYear_Info, {
            params: { gameYearId },
        })
    },

    save(payload) {
        return httpClient.post(API_ROUTES.gameYear_yearCreate, payload)
    },

    getLittleGame(gameYearId, gameType) {
        return httpClient.get(API_ROUTES.gameYear_littleGame, {
            params: { gameYearId, gameType },
        })
    },

    saveLittleRecord(payload) {
        return httpClient.post(API_ROUTES.gameYear_littleRecords, payload)
    },

    createMatch(payload) {
        return httpClient.post(API_ROUTES.gameYear_create, payload)
    },
}
